export default {
  NEXT_STEPS: 3,
  RELATED_LINKS: 4,
};
